var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 1H3C1.89543 1 1 1.89543 1 3V3.66667C1 4.77124 1.89543 5.66667 3 5.66667H3.66667C4.77124 5.66667 5.66667 4.77124 5.66667 3.66667V3C5.66667 1.89543 4.77124 1 3.66667 1Z",
    stroke: "#178477",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 1H10.3335C9.22893 1 8.3335 1.89543 8.3335 3V3.66667C8.3335 4.77124 9.22893 5.66667 10.3335 5.66667H11.0002C12.1047 5.66667 13.0002 4.77124 13.0002 3.66667V3C13.0002 1.89543 12.1047 1 11.0002 1Z",
    stroke: "#178477",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 8.33301H10.3335C9.22893 8.33301 8.3335 9.22844 8.3335 10.333V10.9997C8.3335 12.1042 9.22893 12.9997 10.3335 12.9997H11.0002C12.1047 12.9997 13.0002 12.1042 13.0002 10.9997V10.333C13.0002 9.22844 12.1047 8.33301 11.0002 8.33301Z",
    stroke: "#178477",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 8.33301H3C1.89543 8.33301 1 9.22844 1 10.333V10.9997C1 12.1042 1.89543 12.9997 3 12.9997H3.66667C4.77124 12.9997 5.66667 12.1042 5.66667 10.9997V10.333C5.66667 9.22844 4.77124 8.33301 3.66667 8.33301Z",
    stroke: "#178477",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.1ee916bbac23ee0ca26c9cf7a07fb077.svg";
export { ForwardRef as ReactComponent };